import React, { useState, useEffect } from 'react';
import { getDashboard } from '../api/api';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [eaList, setEaList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await getDashboard();
      setStats(res.data.stats);
      setEaList(res.data.recentList || []);
    } catch (err) {
      console.error('Dashboard fetch error:', err);
    }
    setLoading(false);
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) return '0';
    return Number(num).toLocaleString();
  };

  const getStatusBadge = (dbsts, enddate) => {
    if (dbsts === 'Pending') return <span className="badge badge-pending">대기중</span>;
    if (dbsts === 'D') return <span className="badge badge-denied">거부</span>;
    if (dbsts === 'A') {
      if (enddate) {
        const daysLeft = Math.ceil((new Date(enddate) - new Date()) / (1000 * 60 * 60 * 24));
        if (daysLeft < 0) return <span className="badge badge-expired">만료</span>;
        if (daysLeft <= 10) return <span className="badge badge-pending">만료임박 ({daysLeft}일)</span>;
      }
      return <span className="badge badge-active">활성</span>;
    }
    return <span className="badge">{dbsts}</span>;
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card-icon blue">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <div className="stat-card-label">전체 EA</div>
          <div className="stat-card-value">{stats?.totalCnt || 0}</div>
        </div>

        <div className="stat-card">
          <div className="stat-card-icon green">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="stat-card-label">허용된 EA</div>
          <div className="stat-card-value">{stats?.allowedCnt || 0}</div>
        </div>

        <div className="stat-card">
          <div className="stat-card-icon yellow">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="stat-card-label">대기중</div>
          <div className="stat-card-value">{stats?.waitingCnt || 0}</div>
        </div>

        <div className="stat-card">
          <div className="stat-card-icon red">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="stat-card-label">거부됨</div>
          <div className="stat-card-value">{stats?.deniedCnt || 0}</div>
        </div>
      </div>

      {/* Balance Summary */}
      <div className="stats-grid" style={{ marginBottom: '32px' }}>
        <div className="stat-card">
          <div className="stat-card-label">총 Balance</div>
          <div className="stat-card-value" style={{ fontSize: '24px' }}>
            ${formatNumber(stats?.totalBalance)}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">총 Equity</div>
          <div className="stat-card-value" style={{ fontSize: '24px' }}>
            ${formatNumber(stats?.totalEquity)}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">총 Floating</div>
          <div className="stat-card-value" style={{ fontSize: '24px', color: stats?.totalFloating >= 0 ? '#10B981' : '#EF4444' }}>
            ${formatNumber(stats?.totalFloating)}
          </div>
        </div>
      </div>

      {/* Recent EA List */}
      <div className="table-container">
        <div className="table-header">
          <h2>📋 최근 EA 목록</h2>
        </div>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>상태</th>
                <th>EA명</th>
                <th>Login</th>
                <th>Broker</th>
                <th>Trader</th>
                <th>Balance</th>
                <th>만료일</th>
                <th>마지막 접속</th>
              </tr>
            </thead>
            <tbody>
              {eaList.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center', padding: '40px' }}>
                    등록된 EA가 없습니다.
                  </td>
                </tr>
              ) : (
                eaList.map((ea) => (
                  <tr key={ea.eacheckseq}>
                    <td>{getStatusBadge(ea.dbsts, ea.enddate)}</td>
                    <td><strong>{ea.eaname}</strong></td>
                    <td>{ea.login}</td>
                    <td>{ea.broker}</td>
                    <td>{ea.tradername || '-'}</td>
                    <td>${formatNumber(ea.balance)}</td>
                    <td>{ea.enddate?.substring(0, 10) || '-'}</td>
                    <td>{ea.lastaccessdate?.substring(0, 16) || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
